import type { MessageRule } from '@app/services/admin';

import { preserveDisplayName } from './welcome-message-utils';

type OptStatus = 'PENDING_OPT_IN' | 'OPTED_IN';

export default function buildRule({
  caseType,
  optStatus,
  assignment,
  marleyOptInDisabled,
  body,
  tokens,
  existingRule,
}: {
  caseType: string;
  optStatus?: OptStatus;
  assignment?: 'assigned' | 'unassigned';
  marleyOptInDisabled?: boolean;
  body?: string;
  tokens?: { token: string }[];
  existingRule?: MessageRule;
}): MessageRule {
  const conditions: Array<{
    fact: string;
    operator: 'equal';
    value: string | boolean;
  }> = [{ fact: 'caseType', operator: 'equal', value: caseType }];

  // marleyOptInDisabled flag controls whether we include optStatus
  if (typeof marleyOptInDisabled === 'boolean') {
    conditions.push({
      fact: 'marleyOptInDisabled',
      operator: 'equal',
      value: Boolean(marleyOptInDisabled),
    });
  } else {
    // default false when not explicitly passed
    conditions.push({
      fact: 'marleyOptInDisabled',
      operator: 'equal',
      value: false,
    });
  }

  if (
    typeof marleyOptInDisabled !== 'boolean' ||
    marleyOptInDisabled === false
  ) {
    if (optStatus) {
      conditions.push({
        fact: 'optStatus',
        operator: 'equal',
        value: optStatus,
      });
    }
  }

  if (assignment) {
    conditions.push({
      fact: 'caseAssignment',
      operator: 'equal',
      value: assignment === 'assigned',
    });
  }

  let rule: MessageRule = {
    enabled: existingRule?.enabled ?? true,
    messageTemplate: {
      body,
      tokens,
    },
    rule: existingRule?.rule || {
      conditions: { all: conditions },
    },
  };

  // Preserve ids if present
  if (existingRule?.id && existingRule.id !== 'DEFAULT') {
    rule.id = existingRule.id;
  }
  if (existingRule?.messageTemplate?.id && rule.messageTemplate) {
    rule.messageTemplate.id = existingRule.messageTemplate.id;
  }

  // Always enforce message template category and preserve displayName
  (rule.messageTemplate as Record<string, unknown>).category = 'WELCOME_FLOW';
  rule = preserveDisplayName(rule, existingRule);

  return rule;
}
